import { render, staticRenderFns } from "./OrderItemRow.vue?vue&type=template&id=bb2f5fea&"
import script from "./OrderItemRow.vue?vue&type=script&lang=js&"
export * from "./OrderItemRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports